import { render, staticRenderFns } from "./FiltroPaginaInicialComponent.vue?vue&type=template&id=0b87cbfe&lang=pug"
import script from "./FiltroPaginaInicialComponent.vue?vue&type=script&lang=js"
export * from "./FiltroPaginaInicialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports